import React from 'react';
import { FiDownload, FiTrash2, FiZap, FiX } from 'react-icons/fi';
import IconButton from './IconButton';

/**
 * Sticky toolbar when list rows are multi-selected.
 *
 * Built-in: export / match / delete. Pass `actions` for page-specific bulk ops
 * (e.g. email, status) rendered before the built-ins.
 *
 * actions: [{ key, icon, label, onClick, variant?, show?, disabled? }]
 */
const BulkActionBar = ({
  count,
  onClear,
  onExport,
  onDelete,
  onMatch,
  actions = [],
  showExport = true,
  showDelete = true,
  showMatch = true,
  busy = false,
  busyAction = null,
  className = '',
}) => {
  if (count < 1) return null;

  const customActions = (Array.isArray(actions) ? actions : []).filter(
    (a) => a && a.show !== false && a.icon && a.onClick
  );

  return (
    <div
      className={['bulk-action-bar', className].filter(Boolean).join(' ')}
      role="toolbar"
      aria-label="Bulk actions"
    >
      <span className="bulk-action-bar__count">{count} selected</span>
      <div className="bulk-action-bar__actions page-toolbar">
        {customActions.map((a) => (
          <IconButton
            key={a.key || a.label}
            icon={a.icon}
            label={a.label}
            variant={a.variant}
            onClick={a.onClick}
            disabled={busy || a.disabled}
            loading={busy && busyAction === a.key}
          />
        ))}
        {showExport && onExport && (
          <IconButton
            icon={FiDownload}
            label="Export selected"
            onClick={onExport}
            disabled={busy}
            loading={busy && busyAction === 'export'}
          />
        )}
        {showMatch && onMatch && (
          <IconButton
            icon={FiZap}
            label="Run AI match"
            onClick={onMatch}
            disabled={busy}
            loading={busy && busyAction === 'match'}
          />
        )}
        {showDelete && onDelete && (
          <IconButton
            icon={FiTrash2}
            label="Deactivate selected"
            variant="danger"
            onClick={onDelete}
            disabled={busy}
            loading={busy && busyAction === 'delete'}
          />
        )}
      </div>
      <IconButton
        icon={FiX}
        label="Clear selection"
        variant="ghost"
        size="sm"
        onClick={onClear}
        disabled={busy}
        className="bulk-action-bar__clear"
      />
    </div>
  );
};

export default BulkActionBar;
